import React from "react";
import { Col, Container, Row, Image, Button, Form } from "react-bootstrap";
import { Link } from "react-router-dom";
import IMAGES from "../images/images";
import {
  StackedCarousel,
  ResponsiveContainer,
} from "react-stacked-center-carousel";
import { MdKeyboardArrowLeft, MdKeyboardArrowRight } from "react-icons/md";

export const data = [
  {
    cover: IMAGES.AppImg1,
    title: "Interstaller",
  },
  {
    cover: IMAGES.AppImg2,
    title: "Inception",
  },
  {
    cover: IMAGES.AppImg3,
    title: "Blade Runner 2049",
  },
  {
    cover: IMAGES.AppImg5,
    title: "Icon man 3",
  },
  {
    cover: IMAGES.AppImg4,
    title: "Venom",
  },
];

export const SliderCard = React.memo(function (props) {
  const { data, dataIndex } = props;
  const { cover } = data[dataIndex];
  return (
    <div
      style={{
        backgroundImage: "url(" + IMAGES.PhonePlaceholder + ")",
      }}
      className="placeholderCss"
    >
      <img
        style={{
          objectFit: "cover",
        }}
        alt=""
        draggable={false}
        src={cover}
      />
    </div>
  );
});

const PrivacyScreen = () => {
  const ref = React.useRef();
  return (
    <React.Fragment>
      <section className="bannersection py-5">
        <Container fluid>
          <Row>
            <Col md={12} lg={12} xl={12}>
              <div className="bannersection__content">
                <p className="text-center">Privacy Policy</p>
                <p style={{ fontSize: "16px" }}>
                  At Chummy, protecting your personal information is a
                  cornerstone of our community. This Privacy Policy outlines our
                  practices concerning the collection, use, and sharing of your
                  information through the Chummy app.
                  <br />
                  <br />
                  Information Collection Registration Info :
                  <br /> We collect names, ages, and locations to create your
                  unique profile.
                  <br />
                  <br />
                  Personality Assessment : Detailed answers help us match you
                  with groups that share your interests and personality traits,
                  enhancing your Chummy experience. <br />
                  <br />
                  Communications : <br /> Messages, posts, and interaction data
                  help us monitor app health and user satisfaction. Use of
                  Information <br /> <br />
                  Matchmaking : <br /> Your information is crucial in creating
                  meaningful is crucial in creating meaningful group
                  connections. <br /> <br /> App Improvement: <br /> We analyze
                  usage patterns to enhance functionality and user interface.{" "}
                  <br /> <br /> Communication : <br />
                  Expect updates, safety tips, and service changes from us,
                  aiming to keep you informed and engaged. <br /> <br /> Sharing
                  of Information Your privacy is paramount : <br /> We commit to
                  not selling your personal data to third parties. haring with
                  law enforcement or legal requests will only occur as necessary
                  and required by law. Data Security Implementing top-tier
                  security measures, we strive to protect your information from
                  unauthorized access. However, please be aware that no security
                  system is impenetrable. <br /> <br /> User Rights You're in
                  control : <br /> Access or delete your personal data upon
                  request. Adjust your privacy settings to manage your digital
                  footprint on Chummy. Changes to Privacy Policy We may update
                  this policy to reflect changes in our practices or relevant
                  laws. Significant changes will be communicated to you,
                  requiring your acceptance. Contact Us For privacy inquiries or
                  data management requests, please contact us directly at
                  rocco@chummy.app
                </p>
              </div>
            </Col>
          </Row>
        </Container>
      </section>
    </React.Fragment>
  );
};

export default PrivacyScreen;
